import { render, staticRenderFns } from "./SourceComponent.vue?vue&type=template&id=7095f294&scoped=true&"
import script from "./SourceComponent.vue?vue&type=script&lang=js&"
export * from "./SourceComponent.vue?vue&type=script&lang=js&"
import style0 from "./SourceComponent.vue?vue&type=style&index=0&id=7095f294&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7095f294",
  null
  
)

export default component.exports